import { http } from '../http'
import { URL } from './_constant'

/**
 * 原始档案-列表
 */
export function API_ORIGIN_ARCHIVE_LIST(data?: BasicPageReq) {
  return http.post<ApiOriginArchive.ListRes>(URL.LIST, data)
}

/**
 * 原始档案-全部
 */
export function API_ORIGIN_ARCHIVE_ALL(data?: BasicPageReq) {
  return http.post<ApiOriginArchive.Item[]>(URL.LIST, data)
}

/**
 * 原始档案-详情
 */
export function API_ORIGIN_ARCHIVE_DETAIL(id: string) {
  return http.post<ApiOriginArchive.Item>(URL.DETAIL, { id })
}

/**
 * 原始档案-新增
 */
export function API_ORIGIN_ARCHIVE_ADD(data: ApiOriginArchive.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 原始档案-删除
 */
export function API_ORIGIN_ARCHIVE_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  原始档案-编辑
 */
export function API_ORIGIN_ARCHIVE_EDIT(data: BasicUpdateOneReq<ApiOriginArchive.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  原始档案-禁用
 */
export function API_ORIGIN_ARCHIVE_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 原始档案-启用
 */
export function API_ORIGIN_ARCHIVE_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 原始档案-排序
 */
export function API_ORIGIN_ARCHIVE_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 原始档案-导出
 */
export function API_ORIGIN_ARCHIVE_EXPORT(data: BasicExportReq) {
  return http.post(URL.EXPORT, data)
}
